import arrowIcon from '@/assets/icons/selected-button.png';
import { FiscalYear } from '@/types/fiscalYear';
import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';

interface FiscalYearSidebarProps {
  fiscalYears: FiscalYear[] | undefined;
  selectedFiscalYear: string;
  onSelectFiscalYear: (fiscalYearId: string) => void;
}

export const FiscalYearSidebar: React.FC<FiscalYearSidebarProps> = ({
  fiscalYears,
  selectedFiscalYear,
  onSelectFiscalYear,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        gridArea: 'list',
        display: 'block', // Always visible
        borderRadius: '16px 0 0 16px', // Only left corners rounded
        border: '3px solid rgba(0, 61, 54, 1)',
        overflow: 'hidden',
        backgroundColor: 'rgba(14, 70, 63, 1)',
        height: '100%',
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          pt: 0,
          px: 'clamp(12px, 1.04vw, 20px)',
          pb: 'clamp(18px, 1.56vw, 30px)',
          backgroundColor: 'rgba(14, 70, 63, 1)',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            height: {
              xs: 'clamp(32px, 4vh, 40px)',
              lg: 'clamp(40px, 5vh, 54px)',
            },
            minHeight: {
              xs: 'clamp(32px, 4vh, 40px)',
              lg: 'clamp(40px, 5vh, 54px)',
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: 'clamp(10px, 0.73vw, 14px)',
              color: '#FFFFFF',
              textAlign: 'center',
              lineHeight: 1,
              marginTop: 'clamp(-10px, -0.75vw, -5px)',
            }}
          >
            Fiscal Year
          </Typography>
        </Box>
        {/* Wrapper for scrollable container and All Fiscal Years button */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
          }}
        >
          {/* Scrollable container for fiscal year buttons only */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'auto',
              gap: 'clamp(9px, 0.78vw, 15px)',
              pt: {
                xs: 'clamp(4px, 0.6vh, 12px)',
                lg: 'clamp(12px, 1.6vh, 24px)',
              },
            }}
          >
            {fiscalYears &&
              fiscalYears.length > 0 &&
              fiscalYears.map((fy) => (
                <Button
                  key={fy.id}
                  fullWidth
                  disableRipple
                  disableFocusRipple
                  disableTouchRipple
                  onClick={() => {
                    onSelectFiscalYear(fy.id);
                  }}
                  sx={{
                    justifyContent: 'flex-start',
                    textTransform: 'none',
                    fontFamily: 'Inter, sans-serif',
                    fontSize: 'clamp(11px, 0.85vw, 16px)',
                    minHeight: 'clamp(30px, 1.88vw, 36px)',
                    fontWeight: 500,
                    color: `${selectedFiscalYear === fy.id ? '#7BBCB3' : 'rgba(56, 115, 108, 1)'} !important`,
                    backgroundColor: 'transparent !important',
                    boxShadow: 'none !important',
                    pl: 0,
                    pr: 'clamp(6px, 0.52vw, 10px)',
                    position: 'relative',
                    '&:hover': {
                      backgroundColor: 'transparent !important',
                      boxShadow: 'none !important',
                      color: `${selectedFiscalYear === fy.id ? '#7BBCB3' : 'rgba(56, 115, 108, 1)'} !important`,
                    },
                    '&:active': {
                      backgroundColor: 'transparent !important',
                      boxShadow: 'none !important',
                      color: `${selectedFiscalYear === fy.id ? '#7BBCB3' : 'rgba(56, 115, 108, 1)'} !important`,
                    },
                    '&:focus': {
                      backgroundColor: 'transparent !important',
                      boxShadow: 'none !important',
                      color: `${selectedFiscalYear === fy.id ? '#7BBCB3' : 'rgba(56, 115, 108, 1)'} !important`,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Box
                      sx={{
                        width: 'clamp(8px, 0.52vw, 10px)',
                        height: 'clamp(8px, 0.52vw, 10px)',
                        mr: 'clamp(8px, 0.625vw, 12px)',
                        flexShrink: 0,
                      }}
                    >
                      {selectedFiscalYear === fy.id && (
                        <Box
                          component='img'
                          src={arrowIcon}
                          alt=''
                          sx={{
                            width: 'clamp(8px, 0.52vw, 10px)',
                            height: 'clamp(8px, 0.52vw, 10px)',
                            display: 'block',
                          }}
                        />
                      )}
                    </Box>
                    {fy.endDate.substring(0, 4)}
                  </Box>
                </Button>
              ))}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};
